import { useEffect } from "react";
import { useSavedJobs } from "../../../services/create-resume/queries";
import JobListingItem, { type JobListingItemJob } from "../../JobsPage/components/JobListingItem";

type SavedJob = JobListingItemJob;

type SavedJobsProps = {
	setSelectedJob: (job: SavedJob) => void;
	setShowJobDetailsModal: (open: boolean) => void;
};

function SavedJobs({ setSelectedJob, setShowJobDetailsModal }: SavedJobsProps) {
	const { data: savedJobs, isLoading: isLoadingSavedJobs, refetch } = useSavedJobs();

	useEffect(() => {
		refetch();
	}, []);

	if (isLoadingSavedJobs) {
		return (
			<div className="animate-pulse">
				{[...new Array(5)].map((_, index) => (
					<div className="h-24 bg-gray-900 opacity-10 mb-3 rounded-md" key={index} />
				))}
			</div>
		);
	}

	// useSavedJobs sets retry: 0, so one failed request leaves data undefined while
	// isLoading is already false. Reading .length on that crashed the whole tab.
	const jobs: SavedJob[] = Array.isArray(savedJobs) ? savedJobs : [];

	return (
		<div>
			{jobs.length > 0 ? (
				<div className="divide-y divide-gray-200">
					{jobs.map((job, index) => (
						<JobListingItem
							key={index}
							job={{
								...job,
								logo: job.company ? job.company.logo_url : "/images/co-placeholder.png",
							}}
							onApply={() => {
								setSelectedJob(job);
								setShowJobDetailsModal(true);
							}}
							onClick={() => {
								setSelectedJob(job);
								setShowJobDetailsModal(true);
							}}
							showCompany={true}
							titleClassName="text-base"
							hideSaveButton={true}
							hideSalary={true}
							deleteButton={true}
							showMatchScore
						/>
					))}
				</div>
			) : (
				<div className="text-center py-8 text-gray-500">No saved jobs yet. Save jobs to view them here later.</div>
			)}
		</div>
	);
}

export default SavedJobs;
